import { useDrawer } from '../inc-drawer/inc-drawer.hooks';
import { OrderDetailsDrawerDataType } from './order-details-drawer.component';

export const useOrderDetailsDrawer = () =>
  useDrawer<OrderDetailsDrawerDataType>();
